<div class="tw-flex tw-items-center tw-cursor-pointer" (click)="navigateTo('')">
  <img class="tw-h-5 tw-mr-2" src="../../../../../assets/icons/logo.svg"   alt="PumPumPum Logo" srcset="">
  <!-- <h1 class="tw-text-2xl tw-mb-0">RENAULT</h1> -->
</div>